<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 4H10C10.5128 4 10.9355 4.38604 10.9933 4.88338L11 5V13C11 13.0717 10.9923 13.143 10.9771 13.2128L10.9487 13.3162L8.94868 19.3162C8.82494 19.6874 8.49788 19.9488 8.11604 19.9933L8 20H4C3.35759 20 2.89287 19.4077 3.02037 18.7981L3.05132 18.6838L4.61257 14H3C2.48716 14 2.06449 13.614 2.00673 13.1166L2 13V5C2 4.48716 2.38604 4.06449 2.88338 4.00673L3 4H10H3ZM14 4H21C21.5128 4 21.9355 4.38604 21.9933 4.88338L22 5V13C22 13.0717 21.9923 13.143 21.9771 13.2128L21.9487 13.3162L19.9487 19.3162C19.8249 19.6874 19.4979 19.9488 19.116 19.9933L19 20H15C14.3576 20 13.8929 19.4077 14.0204 18.7981L14.0513 18.6838L15.6126 14H14C13.4872 14 13.0645 13.614 13.0067 13.1166L13 13V5C13 4.48716 13.386 4.06449 13.8834 4.00673L14 4H21H14ZM9 6H4V12H6C6.64241 12 7.10713 12.5923 6.97963 13.2019L6.94868 13.3162L5.38743 18H7.27924L9 12.8377V6ZM20 6H15V12H17C17.6424 12 18.1071 12.5923 17.9796 13.2019L17.9487 13.3162L16.3874 18H18.2792L20 12.8377V6Z"
    fill="currentColor"
  />
</svg>
